module.exports = __webpack_public_path__ + "static/media/hero3.db39aa84.jpg";